const { NODE_ENV, TARGET } = process.env
export const HOST =
	NODE_ENV !== 'production' || TARGET === 'test-build'
		? 'http://dev.api-xiaomang.mgtv.com'
		: 'https://api-xiaomang.mgtv.com'

export const loginUrl = HOST + '/api/login/doLogin' //登录
export const phoneLoginUrl = HOST + '/api/login/doLoginByMobile' //手机验证码登录
export const sendSmsCodeUrl = HOST + '/api/common/sendSmsCode' //发送手机验证码
export const sendUpgradeSmsCodeUrl =
	HOST + '/api/old_business/getUpgradeSmsCode' //历史供应商认证升级 发送手机验证码
export const vertifyUpgradeSmsCodeUrl =
	HOST + '/api/old_business/verfiyUpgradeSmsCode' //历史供应商认证升级 验证升级短信
export const loginInfoUrl = HOST + '/api/login/loginInfo' //登录查询用户信息
export const registerUrl = HOST + '/api/register/doRegister' //注册
export const captchaUrl = HOST + '/api/common/captcha' //获取图片验证码
export const logoutUrl = HOST + '/api/login/logout' //退出登录
export const passwordResetUrl = HOST + '/api/login/passwordReset' //重置密码

export const uploadImgUrl = HOST + '/api/common/uploadImg' //图片上传
export const uploadFileUrl = HOST + '/api/common/uploadFile' //文件上传
